export class WorkspaceInvitation {
  id: number;
  name?: string;
  email: string;
  client: any;
  role: any;
  domains: number[];
}
